import React from 'react'
import { Select, CheckBox, FormConsumer } from './form/form'
import { navigate } from '@reach/router'
import {
    BUSINESS_OPTIONS,
    BROKER,
    INTERESTS_TO_PRODUCTS
} from "../constants/demoRequestsConstants";

const getInterestListForBrokerForm = (formState) => {
    let interestList = []

    Object.keys(INTERESTS_TO_PRODUCTS).forEach(key => {
        if (formState[key]) {
            interestList.push(INTERESTS_TO_PRODUCTS[key]);
        }
    });
    return interestList
}

const handleNextOnStep1 = (formState, props) => {
    if (formState.chooseYourBusiness === BROKER) {
        let interestListForBrokerForm = getInterestListForBrokerForm(formState)
        navigate('/broker-demo-form', { state: {interests: interestListForBrokerForm} })
    } else {
        props.handleNext()
    }
}

const isDisabled = formState => {
    if (
        formState.chooseYourBusiness &&
        (formState.interested_in_spacio ||
            formState.interested_in_connect ||
            formState.interested_in_boost)
    ) {
        return ''
    }
    return 'disabled'
}
const DemoStep1 = props => {

    let getPreSelectedOption = (formState) => {

        if (formState.chooseYourBusiness) {
            let option = BUSINESS_OPTIONS.filter(function(option){
                return option.value === formState.chooseYourBusiness
            });
            if (option[0] && option[0].value) {
                return option[0].value
            }
        }
        return ''
    }
    return (
        <FormConsumer>
            {({ formState }) => (
                <div className="step content">
                    <div className="demo-header">Request a Demo</div>
                    <p className="subheader">
                        See how HomeSpotter can help you improve relationships
                        with your customers.
                    </p>
                    <div className="strong">I am a:</div>
                    <Select
                        name="chooseYourBusiness"
                        options={BUSINESS_OPTIONS}
                        preSelectedOption={getPreSelectedOption(formState)}
                        placeholder={'Choose your business'}
                        required
                    />
                    <div className="strong">I'd like to know more about: </div>
                    <CheckBox
                        name="interested_in_boost"
                        label="<strong>Boost:</strong>Automated digital advertising"
                        checked={formState.interested_in_boost}
                    />
                    <CheckBox
                        name="interested_in_spacio"
                        label="<strong>Spacio:</strong>Listing and open house lead capture"
                        checked={formState.interested_in_spacio}
                    />
                    <CheckBox
                        name="interested_in_connect"
                        label="<strong>Connect:</strong>Mobile apps for search and collaboration"
                        checked={formState.interested_in_connect}
                    />
                    <button
                        disabled={isDisabled(formState)}
                        className={`button button-cta progress ${isDisabled(
                            formState
                        )}`}
                        onClick={() => handleNextOnStep1(formState, props)}
                    >
                        Next
                    </button>
                </div>
            )}
        </FormConsumer>
    )
}

export default DemoStep1
